export const SECTION_ANALYTICS_EVENTS = {
  jobPostCreated: "section job post created"
} as const;

export type SectionAnalyticsSource = "section_jobs";

export type SectionAnalyticsData = {
  source: SectionAnalyticsSource;
  success: boolean;
  sectionId?: string;
  jobPostId?: string;
  action?: string;
  isDraft?: boolean;
  sentForReview?: boolean;
  stage?: string;
};

export function getSectionAnalyticsData({
  source,
  success = true,
  ...rest
}: {
  source: SectionAnalyticsSource;
  success?: boolean;
} & Omit<SectionAnalyticsData, "source" | "success">): SectionAnalyticsData {
  return {
    source,
    success,
    ...Object.fromEntries(Object.entries(rest).filter(([, value]) => value !== undefined && value !== null))
  };
}
